/** Snapshot F2: quién generó y quién hizo el último parcial/final. */

export type RemitoOperatorSource = {
  usuarioNombre?: string | null;
  usuario_nombre?: string | null;
  finalizadoUsuarioNombre?: string | null;
  finalizado_usuario_nombre?: string | null;
};

export function operatorDisplayName(
  source?: {
    usuarioNombre?: string | null;
    usuario_nombre?: string | null;
  } | null,
): string {
  const raw = source?.usuarioNombre || source?.usuario_nombre || "";
  return String(raw).trim();
}

export function remitoOperatorNames(source: RemitoOperatorSource): {
  genero: string;
  ultimaEntrega: string;
} {
  return {
    genero: operatorDisplayName(source),
    ultimaEntrega: String(
      source.finalizadoUsuarioNombre || source.finalizado_usuario_nombre || "",
    ).trim(),
  };
}
